<ba-bub-dropdown
  id="umkreisauswahl"
  (onSelectionChanged)="onChange($event)"
  [selectedValue]="getCurrentSelection()"
  [possibleValues]="range"
  [label]="messages.UMKREISAUSWAHL_LABEL"
  [disabled]="disabled"
  [title]="disabled ? messages.UMKREISAUSWAHL_TITLE : ''"
></ba-bub-dropdown>
